import { Dispatch, SetStateAction } from 'react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';
import { IncomingCall } from '../../types';

export const IncomingCallBarTrail = ({
  setExpandedIncomingCallBar,
  incomingCalls,
  canCollapseCallBar,
  position,
  setPosition,
}: {
  setExpandedIncomingCallBar: (val: boolean) => void;
  incomingCalls: IncomingCall[];
  canCollapseCallBar: boolean;
  position: number;
  setPosition: Dispatch<SetStateAction<number>>;
}) => {
  const disabledLeftArrow = position === 1;
  const disabledRightArrow = position === incomingCalls.length;
  return (
    <>
      {incomingCalls.length > 1 && (
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <NakedButton disabled={disabledLeftArrow} onClick={() => setPosition((prev) => prev - 1)}>
            <Icon color={disabledLeftArrow ? 'disabled' : 'white'} name='caret-left-small' />
          </NakedButton>
          <Text color='white' css={{ flex: 1 }}>
            {position}/{incomingCalls.length}
          </Text>
          <NakedButton disabled={disabledRightArrow} onClick={() => setPosition((prev) => prev + 1)}>
            <Icon color={disabledRightArrow ? 'disabled' : 'white'} name='caret-right-small' />
          </NakedButton>
        </div>
      )}
      {canCollapseCallBar && (
        <NakedButton onClick={() => setExpandedIncomingCallBar(false)}>
          <Icon color='white' name='collapse-left-small' />
        </NakedButton>
      )}
    </>
  );
};
